module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-6-f850da0931a2aa12b048c8d9e9447a35.jpg";